"use client";

import Image from "next/image";
import { Icons } from "@/components/icons";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/* interface IntroProps {
  intro: GetHomeQuery;
} */

export default function Title({ title }: any) {
  // TODO: Fix type
  const imageRef = useRef<HTMLImageElement>(null);

  /* useGSAP(() => {
    gsap.to(imageRef.current, {
      duration: 1,
      ease: "power4.inOut",
      scrollTrigger: {
        trigger: home.heroImage?.url || "",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
      },
    });
  }); */

  return (
    <section className="cs-container">
      <div className="flex flex-col bg-white pt-12 md:pt-24 lg:items-center">
        <h1 className="mb-6 font-extrabold lg:text-center" dangerouslySetInnerHTML={{ __html: title.title }}></h1>
        <h2
          className="mb-16 text-3xl font-normal lg:text-center"
          dangerouslySetInnerHTML={{ __html: title.subtitle }}
        ></h2>
      </div>
    </section>
  );
}
